import * as React from "react";
import { BrManageContentButton } from "@bloomreach/react-sdk";
import { ScrollUpButton } from "@grandvisionhq/common";
import { RelatedLinks } from "@grandvisionhq/content";
import { useAlgoliaConfig, AlgoliaProviders, useAlgoliaData, TealiumProductListingPageView, SearchPageHeader, ConnectedProductListing } from "@grandvisionhq/search";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { useWordLiftRelatedLinks } from "@grandvisionhq/svc-wordlift";
import { compose } from "@grandvisionhq/utils";
import { CmsProductCatalogBreadcrumbs } from "../../../Breadcrumbs/ProductCatalogBreadcrumbs/containers/Breadcrumbs/ProductCatalogBreadcrumbs/ProductCatalogBreadcrumbs.js";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachSiteLogos } from "../../../../hooks/hooks/use-bloomreach-site-logos.js";
import { useBloomreachPageModels } from "../../../../hooks/hooks/use-bloomreach-page-models.js";
function getPromotion({
  page,
  ref
}) {
  const document = ref && page.getContent(ref);
  const content = document?.getData();
  if (!document) {
    return void 0;
  }
  return {
    ...content,
    links: content?.links[0],
    manageContentButton: /* @__PURE__ */ React.createElement(BrManageContentButton, { content: document })
  };
}
const CmsProductCatalog = ({ page, content }) => {
  const { isEnabled } = useAlgoliaConfig();
  if (!isEnabled) {
    console.error(
      "You're trying to render the <CmsProductCatalog />, but the `AlgoliaConfig` is not configured properly."
    );
    return null;
  }
  return /* @__PURE__ */ React.createElement(AlgoliaProviders, null, /* @__PURE__ */ React.createElement(CmsProductCatalogContent, { page, content }));
};
const CmsProductCatalogContent = ({ page, content }) => {
  const { total, facetOrder } = useAlgoliaData();
  const { getLabel } = useIntl();
  const siteLogos = useBloomreachSiteLogos();
  const { productType } = useBloomreachPageModels() || {};
  const { title, smallPromotion, bigPromotion } = content;
  const productPageSelector = content.productPageSelector?.filter((item) => item.url && item.label);
  const promotionSmall = getPromotion({ page, ref: smallPromotion });
  const promotionBig = getPromotion({ page, ref: bigPromotion });
  const { isWordLiftRelatedLinksEnabled } = useFeatureToggles();
  const { fetchRelatedLinks, relatedLinks, rawResult } = useWordLiftRelatedLinks();
  React.useEffect(() => {
    if (isWordLiftRelatedLinksEnabled) {
      fetchRelatedLinks();
    }
  }, [fetchRelatedLinks, isWordLiftRelatedLinksEnabled]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsProductCatalogBreadcrumbs, { title }), /* @__PURE__ */ React.createElement(TealiumProductListingPageView, { productType }), /* @__PURE__ */ React.createElement(
    SearchPageHeader,
    {
      pageTitle: title,
      hitTitle: `${total} ${getLabel("search.results.amount.title")}`,
      description: content.description?.value,
      facetOrder,
      productPageSelector
    }
  ), /* @__PURE__ */ React.createElement(
    ConnectedProductListing,
    {
      promotionSmall,
      promotionBig,
      reimbursableLogos: {
        default: siteLogos.reimbursable,
        alternative: siteLogos.reimbursableAlternative
      }
    }
  ), /* @__PURE__ */ React.createElement(RelatedLinks, { rawResult, relatedLinks }), /* @__PURE__ */ React.createElement(ScrollUpButton, null));
};
const ProductCatalog = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsProductCatalog);
export {
  CmsProductCatalog,
  ProductCatalog as default
};
//# sourceMappingURL=ProductCatalog.js.map
